import { Toast } from 'primereact/toast';
import { useEffect, useRef, useState } from 'react';

const ToastService = () => {
  const toast = useRef(null);
  const [position, setPosition] = useState(localStorage.getItem('toastPosition') || 'top-right');

  useEffect(() => {
    localStorage.setItem('toastPosition', position);
  }, [position]);


  const show = (options) => {
    if (!options) return;

    if (Array.isArray(options)) {
      options.forEach(opt => show(opt));
      return;
    }

    if (options.content) {
      toast?.current?.show(options);
      return;
    }

    const { severity = 'info', summary, detail, life = 3000, ...rest } = options;

    let iconClass = options.icon;
    let title = "Info";

    if (!iconClass) {
      if (severity === "success") {
        iconClass = "fa-solid fa-circle-check";
        title = "Success";
      } else if (severity === "warn") {
        iconClass = "fa-solid fa-triangle-exclamation";
        title = "Warning";
      } else if (severity === "error") {
        iconClass = "fa-solid fa-circle-xmark";
        title = "Error";
      } else if (severity === "secondary") {
        iconClass = "fa-solid fa-bell";
        title = "Notification";
      } else if (severity === "contrast") {
        iconClass = "fa-solid fa-circle-half-stroke";
        title = "Attention";
      } else {
        iconClass = "fa-solid fa-circle-info";
      }
    }

    const formatToastDetail = (message) => {
      if (typeof message === 'string' && message.includes('\n')) {
        const htmlMessage = message.replace(/\n/g, '<br />');
        return <span dangerouslySetInnerHTML={{ __html: htmlMessage }} />;
      }
      return message;
    };

    const wrappedOptions = {
      ...rest,
      severity,
      life,
      content: (message, props = {}) => {
        const onClose = props?.onClose;
        return (
          <div className="p-toast-message-content">
            <i className={`${iconClass} p-toast-message-icon`} style={{ fontSize: "18px", marginTop: "2px", flexShrink: 0 }} />
            <div className="p-toast-message-text">
              <span className="p-toast-summary">{summary || title}</span>
              <div className="p-toast-detail">{formatToastDetail(detail)}</div>
            </div>
            <button 
              type="button" 
              className="p-toast-icon-close p-link" 
              onClick={onClose}
            >
              <i className="srkay-close" style={{ fontSize: "12px" }} />
            </button>
            <div 
              className="p-toast-progress-bar" 
              style={{ animationDuration: `${life}ms` }}
            />
          </div>
        );
      }
    };

    toast?.current?.show(wrappedOptions);
  };

  const showToast = (severity, summary, detail, life = 3000) => {
    show({ severity, summary, detail, life });
  };

  return {
    ToastComponent: <span><Toast ref={toast} position={position} /></span>,
    show,
    showToast,
    position,
    setPosition,
    showSuccess: (summary, detail, life) => showToast('success', summary, detail, life),
    showInfo: (summary, detail, life) => showToast('info', summary, detail, life),
    showWarn: (summary, detail, life) => showToast('warn', summary, detail, life),
    showError: (summary, detail, life) => showToast('error', summary, detail, life),
    showSecondary: (summary, detail, life) => showToast('secondary', summary, detail, life),
    showContrast: (summary, detail, life) => showToast('contrast', summary, detail, life),
  };
};

export default ToastService;